import React from "react";

import { PERSON_NAME, TWITTER_HANDLE } from "../site";

/**
 * Open Graph meta elements, as an array to spread inside <Helmet>
 * (Helmet only reads its direct children, so these cannot be a component).
 * Optional fields that are empty emit no tag.
 * @param {{ title: string, image: string, type: string, description?: string, url?: string | null, locale?: string }} fields
 */
export function openGraphTags({ title, description, image, url, type, locale }) {
	return [
		<meta key="og:type" property="og:type" content={type} />,
		<meta key="og:site_name" property="og:site_name" content={PERSON_NAME} />,
		url && <meta key="og:url" property="og:url" content={url} />,
		<meta key="og:title" property="og:title" content={title} />,
		description && (
			<meta key="og:description" property="og:description" content={description} />
		),
		<meta key="og:image" property="og:image" content={image} />,
		<meta key="og:image:width" property="og:image:width" content="1200" />,
		<meta key="og:image:height" property="og:image:height" content="630" />,
		locale && <meta key="og:locale" property="og:locale" content={locale} />,
	].filter(Boolean);
}

/**
 * Twitter card meta elements, as an array to spread inside <Helmet>; `creator` adds twitter:creator.
 * @param {{ title: string, image: string, description?: string, creator?: boolean }} fields
 */
export function twitterTags({ title, description, image, creator = false }) {
	return [
		<meta key="twitter:card" name="twitter:card" content="summary_large_image" />,
		<meta key="twitter:site" name="twitter:site" content={TWITTER_HANDLE} />,
		creator && <meta key="twitter:creator" name="twitter:creator" content={TWITTER_HANDLE} />,
		<meta key="twitter:title" name="twitter:title" content={title} />,
		description && (
			<meta key="twitter:description" name="twitter:description" content={description} />
		),
		<meta key="twitter:image" name="twitter:image" content={image} />,
	].filter(Boolean);
}
